import ReactDOM from 'react-dom';

import App from './app';
import './assets/css/index.css';

const container = document.getElementById('root');

ReactDOM.render(<App />, container);
